import layoutHeaderAside from '@/layout/header-aside'

import pigeon from './modules/pigeon'

import member from './modules/member'
import payfee from './modules/payfee'
import operate from './modules/operate'
import center from './modules/center'
import matchlist from './modules/matchlist'
import shed from './modules/shed'
import tools from './modules/tools'
import publish from './modules/publish'
import message from './modules/message'
import sagerui from './sageruirouter/sagertui'
// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
/**
 * 在主框架内显示
 */
const frameIn = [
  {
    path: '/',
    redirect: { name: 'index' },
    component: layoutHeaderAside,
    children: [
      // 首页
      {
        path: 'index',
        name: 'index',
        meta: {
          title: '首页',
          auth: true
        },
        component: _import('system/index')
      },
      // // 演示页面
      // {
      //   path: 'page1',
      //   name: 'page1',
      //   meta: {
      //     title: '页面 1',
      //     auth: true
      //   },
      //   component: _import('demo/page1')
      // },
      // {
      //   path: 'page2',
      //   name: 'page2',
      //   meta: {
      //     title: '页面 2',
      //     auth: true
      //   },
      //   component: _import('demo/page2')
      // },
      // 系统 前端日志
      {
        path: 'log',
        name: 'log',
        meta: {
          title: '前端日志',
          auth: true
        },
        component: _import('system/log')
      },
      // 刷新页面 必须保留
      {
        path: 'refresh',
        name: 'refresh',
        hidden: true,
        component: _import('system/function/refresh')
      },
      // 页面重定向 必须保留
      {
        path: 'redirect/:route*',
        name: 'redirect',
        hidden: true,
        component: _import('system/function/redirect')
      },
      // 暂无权限页面
      {
        path: 'noPermission',
        name: 'NoPermission',
        meta: {
          title: '暂无权限',
          auth: false
        },
        hidden: true,
        component: _import('system/noPermission')
      },
      ...tools

    ]
  },
  ...payfee,
  ...pigeon,
  ...member,
  ...operate,
  ...center,
  ...matchlist,
  ...shed,
  ...publish,
  ...message,
  ...message
  // ...match
]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: _import('system/login')
  },
  ...sagerui
]

/**
 * 错误页面
 */
const errorPage = [
  {
    path: '*',
    name: '404',
    component: _import('system/error/404')
  }
]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [...frameIn, ...frameOut, ...errorPage]
